import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const blockUser = async (userId, blockData, token) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/users/block/${userId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(blockData),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Failed to block user");
  }
  return data;
};

const useBlockUser = () => {
  const queryClient = useQueryClient();
  const { token } = useContext(AuthContext);

  return useMutation(({ userId, blockData }) => blockUser(userId, blockData, token), {
    onSuccess: (_data, { userId }) => {
      queryClient.invalidateQueries("merchants");
      queryClient.invalidateQueries("customers");
      queryClient.invalidateQueries(["user", userId]);
      queryClient.invalidateQueries(["customer", userId]);
    },
  });
};

export default useBlockUser;
